import {useState, useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
// material
import {Button, Card, Container, Stack, TextField, Typography} from '@mui/material';
import Page from 'src/components/Page';
import DynamicList from 'src/components/DynamicList';
import {useModal} from 'src/hooks/useModal';
import {DynamicForm} from 'vetrina-ui';
import {
	getAmountValidation,
	getRequiredStringValidation,
	nameValidation,
} from 'src/schema/commanValidationSchema';
import {request} from 'src/utils/AdminApi';
import {toast} from 'react-toastify';
import {useQueryClient} from 'react-query';
import DeleteAlertDialog from 'src/components/modals/DeleteAlertDialog';
import {handleRequestError} from 'src/utils/helperMethods';
import buildGetInputProps from 'src/utils/getInputProps';
import {getTextfieldDate} from 'src/utils/date';

export default function CouponsPage({}) {
	const {open, close} = useModal();
	const navigate = useNavigate();
	const [state, setState] = useState();
	const api_route = '/coupons';
	useEffect(() => {}, []);

	return (
		<Page title="الكوبونات">
			<Container maxWidth="md">
				<Card sx={{p: 3}}>
					<Stack spacing={2}>
						<Stack direction="row" justifyContent="space-between">
							<Typography variant="h4">الكوبونات</Typography>
							<Button
								onClick={() => {
									open({
										title: 'اضافة كوبون',
										children: <CouponForm onSuccess={() => close()} />,
									});
								}}
							>
								اضافة
							</Button>
						</Stack>

						<DynamicList
							api_route={api_route}
							RowComponent={({item, refetch}) => (
								<Stack justifyContent="space-between" direction="row">
									<Typography>{item.name}</Typography>
									<Stack spacing={1} direction="row">
										<Button
											onClick={() => {
												open({
													title: 'تعديل كوبون',
													children: <CouponForm initialData={item} onSuccess={() => close()} />,
												});
											}}
										>
											تعديل
										</Button>
										<DeleteAlertDialog
											onDelete={async () => {
												const toastId = toast.loading('جاري الحذف');
												try {
													await request(`/coupons/${item.id}`, 'DELETE');
													toast.update(toastId, {render: 'تم الحذف بنجاح', type: 'success', isLoading: false});
													refetch();
												} catch (err) {
													toast.update(toastId, {
														render: handleRequestError(err),
														type: 'error',
														isLoading: false,
													});
												}
											}}
										/>
									</Stack>
								</Stack>
							)}
						/>
					</Stack>
				</Card>
			</Container>
		</Page>
	);
}

const CouponForm = ({initialData, onSuccess}) => {
	const isEdit = initialData?.id;
	const queryClient = useQueryClient();

	return (
		<DynamicForm
			submitButtonText={isEdit ? 'تعديل' : 'اضافة'}
			initialValues={initialData}
			config={{
				inputs: [
					{
						name: 'name',
						type: 'text',
						label: 'الاسم',
						validation: nameValidation.required('يرجي ادخال اسم الكوبون'),
					},
					{
						name: 'code',
						type: 'text',
						label: 'الكود',
						validation: nameValidation.required('يرجي ادخال كود الكوبون'),
					},
					{
						name: 'discount',
						type: 'number',
						label: 'نسبة الخصم',
						validation: getAmountValidation()
							.max(100, 'ادخل نسبة تخفيض صحيحة')
							.required('يرجي ادخال نسبة الخصم'),
						// validation: ,
					},
					{
						name: 'limit',
						type: 'number',
						label: 'عدد مرات الاستخدام (اختياري)',
						validation: getAmountValidation().min(1, 'ادخل رقم اكبر او يساوي 1'),
						// validation: ,
					},
					{
						name: 'expiration',
						component: ({input, formik}) => {
							const props = buildGetInputProps(formik)('expiration');

							console.log('formated', getTextfieldDate(props.value));
							return (
								<TextField
									{...props}
									value={getTextfieldDate(props.value)}
									label="تاريخ انتهاء الصلاحية"
									placeholder="تاريخ انتهاء الصلاحية"
									InputLabelProps={{shrink: true}}
									type="datetime-local"
									fullWidth
								/>
							);
						},
						validation: getRequiredStringValidation('يرجي ادخال تاريخ انتهاء الصلاحية'),
					},
				],
			}}
			onSubmit={async (formData) => {
				try {
					if (isEdit) await request(`/coupons/${initialData.id}`, 'PUT', formData);
					else await request('/coupons', 'POST', formData);

					toast.success(isEdit ? 'تم التعديل بنجاح' : 'تم الاضافة بنجاح');
					queryClient.invalidateQueries(['/coupons']);

					if (onSuccess) onSuccess();
				} catch (err) {
					toast.error('حدث خطاء غير متوقع');
				}
			}}
		/>
	);
};
